import { render, staticRenderFns } from "./ForgotPasswordForm.vue?vue&type=template&id=6524a747"
import script from "./ForgotPasswordForm.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordForm.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordForm.vue?vue&type=style&index=0&id=6524a747&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports